var map = {
	"./arrowRight.svg": "OeQi",
	"./flow-fabu.svg": "5ixI",
	"./flow-jiaoyi.svg": "W/5d",
	"./flow-pipei.svg": "eUwa",
	"./flow-ruzhu.svg": "L7X2",
	"./project-money.svg": "88OY",
	"./project-nums.svg": "qWNG",
	"./project-users.svg": "n1yT",
	"./solution1.svg": "3Zgs",
	"./solution2.svg": "8NkH",
	"./solution3.svg": "bJ6C",
	"./solution4.svg": "Ty+I",
	"./solution5.svg": "zIFc",
	"./solution6.svg": "wGg7",
	"./white-solution1.svg": "NAmO",
	"./white-solution2.svg": "n2sQ",
	"./white-solution3.svg": "zkwv",
	"./white-solution4.svg": "RrsV",
	"./white-solution5.svg": "X1Eo",
	"./white-solution6.svg": "TP2t"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vEma";


//////////////////
// WEBPACK FOOTER
// ./src/icons/home nonrecursive \.svg$
// module id = vEma
// module chunks = 13